import { render, staticRenderFns } from "./technologyFee.vue?vue&type=template&id=2edee6fe&scoped=true"
import script from "./technologyFee.vue?vue&type=script&lang=js"
export * from "./technologyFee.vue?vue&type=script&lang=js"
import style0 from "./technologyFee.vue?vue&type=style&index=0&id=2edee6fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edee6fe",
  null
  
)

export default component.exports